import "./recentCases.css";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

import { useAuth } from "../../../context/AuthContext";
import { getRecentCases } from "../../../services/dashboardService";



export default function RecentCases() {
  const navigate = useNavigate();

const { globalUser } = useAuth();

const [cases, setCases] = useState([]);

useEffect(() => {
  if (!globalUser?.uid) return;

  const loadCases = async () => {
    const data = await getRecentCases(globalUser.uid);
    setCases(data);
  };

  loadCases();
}, [globalUser]);
  return (
    <div className="dashboard-panel">

      <div className="panel-header">
        <div className="panel-title">
          <span>Recent Cases</span>
        </div>

        <button className="panel-link"
        onClick={() => navigate("/portal/allcases")}>
          View all cases
        </button>
      </div>

      <div className="recent-list">
  {cases.length === 0 ? (
    <div className="no-hearings">
      No recent cases
    </div>
  ) : (
    cases.map((item) => (
      <div className="recent-item" key={item.id}>

        <div className="recent-info">
          <h4>
            {item.petitionerName} vs. {item.respondentName}
          </h4>

          <p>{item.courtName}</p>
        </div>

        <span
          className={`recent-status ${
            (item.status || "").toLowerCase() === "disposed" ? "disposed" : ""
          }`}
        >
          {item.status || "Pending"}
        </span>

      </div>
    ))
  )}
</div>

    </div>
  );
}